export default __webpack_public_path__ + "static/media/08.0165f22c.jfif";